import type { Section } from '@mc/faq'
import { Trans } from '@mc/i18n'
import { BUNDLE_AD_LANDING_I18N_NAMESPACE, i18nInstance } from '../../../i18n'
import { components } from './common'

const t = i18nInstance.getFixedT(null, BUNDLE_AD_LANDING_I18N_NAMESPACE)

export const getOnCallSection = (): Section => ({
  title: t('page.landing.faq.onCall.title'),
  questions: [
    {
      title: t('page.landing.faq.onCall.question1'),
      uuid: 'faq.onCall.question1',
      answer: (
        <p className='mc-opacity--hinted'>
          <Trans
            i18nKey='page.landing.faq.onCall.answer1'
            ns={BUNDLE_AD_LANDING_I18N_NAMESPACE}
            components={components}
          />
        </p>
      ),
    },
    {
      title: t('page.landing.faq.onCall.question2'),
      uuid: 'faq.onCall.question2',
      answer: (
        <p className='mc-opacity--hinted'>
          <Trans
            i18nKey='page.landing.faq.onCall.answer2'
            ns={BUNDLE_AD_LANDING_I18N_NAMESPACE}
            components={components}
          />
        </p>
      ),
    },
    {
      title: t('page.landing.faq.onCall.question3'),
      uuid: 'faq.onCall.question3',
      answer: (
        <p className='mc-opacity--hinted'>
          <Trans
            i18nKey='page.landing.faq.onCall.answer3'
            ns={BUNDLE_AD_LANDING_I18N_NAMESPACE}
            components={components}
          />
        </p>
      ),
    },
    {
      title: t('page.landing.faq.onCall.question4'),
      uuid: 'faq.onCall.question4',
      answer: (
        <p className='mc-opacity--hinted'>
          <Trans
            i18nKey='page.landing.faq.onCall.answer4'
            ns={BUNDLE_AD_LANDING_I18N_NAMESPACE}
            components={components}
          />
        </p>
      ),
    },
    {
      title: t('page.landing.faq.onCall.question5'),
      uuid: 'faq.onCall.question5',
      answer: (
        <p className='mc-opacity--hinted'>
          <Trans
            i18nKey='page.landing.faq.onCall.answer5'
            ns={BUNDLE_AD_LANDING_I18N_NAMESPACE}
            components={components}
          />
        </p>
      ),
    },
  ],
})
